import axios from 'axios';
import { API_RESPONSE, PREVIEW_DATABASE_URL, PREVIEW_DATABASE_URL_LOCALHOST } from '../settings/shared/constants';
import { constructPreviewUrls } from '../settings/shared/commonMethods';

const axiosClientDB = axios.create({
    baseURL: localStorage.getItem('environmentType') === "K8S" ? PREVIEW_DATABASE_URL : PREVIEW_DATABASE_URL_LOCALHOST,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor
axiosClientDB.interceptors.request.use(function (config) {
    const projectId = config.headers['project-id'] || config.headers['Project-Id'];

    if (projectId) {
      // Construct new base URL dynamically
      config.baseURL = localStorage.getItem('environmentType') === "K8S" ?
            constructPreviewUrls(PREVIEW_DATABASE_URL, projectId) : PREVIEW_DATABASE_URL_LOCALHOST
    //   console.log('🔗 Dynamic Base URL:', config.baseURL);
    }
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axiosClientDB.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
}, function (error) {
        let resp = {
            errorMessage : error?.message +" : " + error.code,
            status: API_RESPONSE.FAILED
        }
       return resp;
});

export default axiosClientDB;    